export enum NotificationTypes {
  assignedCandidate = 'assignedCandidate',
  updatedAssignedCandidate = 'updatedAssignedCandidate',
  commentedCandidate = 'commentedCandidate',
}
